import { render, staticRenderFns } from "./ClarificationFullDialog.vue?vue&type=template&id=51afd52f&"
import script from "./ClarificationFullDialog.vue?vue&type=script&lang=js&"
export * from "./ClarificationFullDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports